import planReadyPNG from '~/assets/images/communication/plan-ready.png'
import planReadyWEBP from '~/assets/images/communication/plan-ready.webp'
import InfoPage from '~/pages/communication/libs/InfoPage'
import { TPageProps } from '~/shared/types/commonTypes'

const PlanReadyCommunication = (props: TPageProps) => (
  <InfoPage
    {...props}
    question="Your communication plan is 92% ready!"
    titleI18nKey="onboarding.communicationPlanReady.title"
    subtitleI18nKey="onboarding.communicationPlanReady.subtitle"
    imagePng={planReadyPNG}
    imageWebp={planReadyWEBP}
    imageAlt="Your communication plan is 92% ready!"
    contentGap={32}
  />
)

export default PlanReadyCommunication
